import React, { useContext } from 'react';
import {
  OUTSTATION,
  OUTSTATION_ROUND_TRIP,
  RENTALS
} from '../../../constants/tripTypes';
import { getAppEnv } from '../../../../config/env';
import {
  CabsLandingContext,
  CabsLandingDispatchContext
} from '../../../CabsLandingContext';
import {
  MOB_CABS_OW_CALENDAR_PICKUP_TIME_CLICK,
  MOB_CABS_OW_CALENDAR_DROP_TIME_CLICK,
  MOB_CABS_AT_CALENDAR_PICKUP_TIME_CLICK,
  MOB_CABS_HR_CALENDAR_PICKUP_TIME_CLICK
} from '../../../constants/omnitureConstants';
import { cabsLandingWidgetInfo } from '../../../cabsLandingWidgetInfo';
import { SET_AIRPORT_RIDE_NOW, SET_WIDGET } from '../cabsLandingPageState';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

const days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

export const RoundTripDateInput = ({
  widgetComponent,
  widget,
  setWidget,
  selectedDeptDate,
  selectedReturnDate,
  widgetNumber,
  setIsDropWidgetClicked
}) => {
  return (
    <div className="makeFlex">
      <DateInputUnit
        widget={widget}
        setWidget={setWidget}
        selectedDeptDate={selectedDeptDate}
        widgetComponent={widgetComponent}
        widgetNumber={widgetNumber}
        inputTitle={'PICK UP TIME'}
      />
      <DateInputUnit
        widget={widget}
        setWidget={setWidget}
        selectedDeptDate={selectedReturnDate}
        widgetComponent={widgetComponent}
        widgetNumber={widgetNumber}
        inputTitle={'DROP TIME'}
        setIsDropWidgetClicked={setIsDropWidgetClicked}
      />
    </div>
  );
};

const setOmniture = (inputTitle, travelFor, trackTemplateEvent) => {
  if (travelFor.includes(OUTSTATION)) {
    if (inputTitle === 'PICK UP TIME')
      trackTemplateEvent(MOB_CABS_OW_CALENDAR_PICKUP_TIME_CLICK);
    else trackTemplateEvent(MOB_CABS_OW_CALENDAR_DROP_TIME_CLICK);
  } else if (travelFor.includes(RENTALS)) {
    trackTemplateEvent(MOB_CABS_HR_CALENDAR_PICKUP_TIME_CLICK);
  } else {
    trackTemplateEvent(MOB_CABS_AT_CALENDAR_PICKUP_TIME_CLICK);
  }
};

export const DateInputUnit = ({
  widgetComponent,
  airportRideNow,
  setAirportRideNow,
  widget,
  setWidget,
  selectedDeptDate,
  widgetNumber,
  inputTitle,
  showRideNowOptions = false,
  setIsDropWidgetClicked
}: {
  widgetComponent;
  airportRideNow?;
  setAirportRideNow?;
  widget;
  setWidget;
  selectedDeptDate;
  widgetNumber;
  inputTitle;
  showRideNowOptions?;
  setIsDropWidgetClicked?;
}) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const { trackTemplateEvent, travelFor } = cabsLandingContext;
  const isAirportRideNow = airportRideNow && showRideNowOptions;

  const formatTime = (date: Date) => {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const amPm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = String(hours % 12 || 12).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes} ${amPm}`;
  };
  return (
    <>
      <div
        id="pickup date"
        style={{
          marginTop: '10px',
          backgroundColor: 'rgb(247, 247, 247)',
          border: '1px solid rgb(231, 231, 231)'
        }}
        className={`makeFlex fullWidth cabsLandingRsw rsw`}
      >
        <div
          className="makeFlex alignCenter fullWidth"
          onClick={() => {
            if (inputTitle === 'DROP TIME') {
              setIsDropWidgetClicked(true);
            }
            setOmniture(inputTitle, travelFor, trackTemplateEvent);
            !isAirportRideNow && setWidget(widgetNumber, inputTitle);
          }}
        >
          <div className="makeFlex alignCenter fullWidth">
            <img
              className="appendRight10"
              src={`${PUBLIC_URL}/static/public/calendar_gray.webp`}
              height={'24px'}
              width={'24px'}
              alt="logo"
            />
            <div>
              <div
                style={{ color: 'rgb(155, 155, 155)' }}
                className="font11 latoBold appendBottom3"
              >
                {inputTitle}
              </div>
              {isAirportRideNow ? (
                <div className="latoBlack blackText font14 appendTop3">
                  Ride Now
                </div>
              ) : (
                <div className="latoBlack blackText">{`${selectedDeptDate.getDate()} ${
                  months[selectedDeptDate.getMonth()]
                }, ${formatTime(selectedDeptDate)}`}</div>
              )}
              {isAirportRideNow ? null : (
                <div style={{ color: 'rgb(74, 74, 74)', fontSize: '12px' }}>
                  {days[selectedDeptDate.getDay()]}
                </div>
              )}
            </div>
          </div>
        </div>
        {showRideNowOptions ? (
          <div className="makeFlex pushRight alignCenter">
            <div
              onClick={() => setAirportRideNow(false)}
              style={{
                marginRight: '5px',
                borderRadius: '4.5px',
                padding: '8px',
                border: !airportRideNow
                  ? '1px solid rgb(0, 140, 255)'
                  : '1px solid rgb(231, 231, 231)',
                background: 'rgb(255, 255, 255)',
                fontSize: '12px',
                boxShadow: airportRideNow
                  ? 'rgba(0, 0, 0, 0.4) 0px 1px 1px'
                  : '',
                color: !airportRideNow ? 'rgb(0, 140, 255)' : undefined
              }}
            >
              Schedule
            </div>
            <div
              onClick={() => setAirportRideNow(true)}
              style={{
                marginRight: '5px',
                borderRadius: '4.5px',
                padding: '8px',
                border: airportRideNow
                  ? '1px solid rgb(0, 140, 255)'
                  : '1px solid rgb(231, 231, 231)',
                background: 'rgb(255, 255, 255)',
                fontSize: '12px',
                boxShadow: !airportRideNow
                  ? 'rgba(0, 0, 0, 0.4) 0px 1px 1px'
                  : '',
                color: airportRideNow ? 'rgb(0, 140, 255)' : undefined
              }}
            >
              Ride Now
            </div>
          </div>
        ) : null}
      </div>
      {widget === widgetNumber && widgetComponent}
    </>
  );
};

export const DateInputBasedOnTrip = ({
  widgetComponent,
  setIsDropWidgetClicked
}) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const dispatch = useContext(CabsLandingDispatchContext);

  const {
    travelFor,
    selectedDeptDate,
    selectedReturnDate,
    widget,
    stopOvers,
    airportRideNow
  } = cabsLandingContext;

  const setWidget = widgetNumber => {
    dispatch && dispatch({ type: SET_WIDGET, newStateValue: widgetNumber });
  };
  const setAirportRideNow = airportRideNow => {
    dispatch &&
      dispatch({ type: SET_AIRPORT_RIDE_NOW, newStateValue: airportRideNow });
  };

  const isStopOversPresent = stopOvers.length > 0;
  const showPickupAndDropDate =
    travelFor === OUTSTATION_ROUND_TRIP ||
    (travelFor.includes(OUTSTATION) && isStopOversPresent);

  return showPickupAndDropDate ? (
    <RoundTripDateInput
      widget={widget}
      setWidget={setWidget}
      selectedDeptDate={selectedDeptDate}
      selectedReturnDate={selectedReturnDate}
      widgetComponent={widgetComponent}
      widgetNumber={cabsLandingWidgetInfo.NEW_DATE_TIME_PICKER}
      setIsDropWidgetClicked={setIsDropWidgetClicked}
    />
  ) : (
    <DateInputUnit
      airportRideNow={airportRideNow}
      setAirportRideNow={setAirportRideNow}
      widget={widget}
      setWidget={setWidget}
      selectedDeptDate={selectedDeptDate}
      widgetComponent={widgetComponent}
      widgetNumber={cabsLandingWidgetInfo.NEW_DATE_TIME_PICKER}
      inputTitle={'PICK UP TIME'}
      showRideNowOptions={false}
    />
  );
};
